import {
  Button,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@ais-ui/ui-core';
import React, { useState } from 'react';
import { PiBroadcast, PiChatCircleText, PiChatsCircle } from 'react-icons/pi';
import { useLocalization } from '@ais-ui/locale-management';
import { noop } from 'lodash';
import { SendMessage } from './mutations/SendMessage';
import { CreateMessageSchedule } from './mutations/CreateMessageSchedule';

interface MessageButtonProps {
  id: string;
  Icon: React.ElementType;
  onClick: () => void;
  text: string;
}

const MessageButton = ({ id, Icon, onClick, text }: MessageButtonProps) => {
  return (
    <Button
      id={id}
      variant="ghost"
      onClick={onClick}
      className="flex gap-x-2 col-span-2 justify-start"
    >
      <Icon></Icon>
      {text}
    </Button>
  );
};

export const MessageActionsMenu = ({
  buttonText,
  className,
}: {
  buttonText: string;
  className?: string;
}) => {
  const { messages } = useLocalization();
  const [isOpen, setIsOpen] = useState(false);
  const [showSendMessageDialog, setShowSendMessageDialog] = useState(false);
  const [showScheduleMessageDialog, setShowScheduleMessageDialog] =
    useState(false);

  return (
    <div className="flex w-full justify-end">
      <Popover open={isOpen} onOpenChange={setIsOpen}>
        <PopoverTrigger asChild>
          <Button id="create-message-button" className={className}>
            {buttonText}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-fit" side="left" align="end">
          <div className="grid gap-4">
            <div className="space-y-2">
              <h4 className="font-medium leading-none">Messages</h4>
              <p className="text-sm text-muted-foreground">
                Send and schedule messages
              </p>
            </div>
            <div className="grid gap-2"></div>
          </div>
          <div className="grid grid-cols-4">
            <MessageButton
              id="send-message-button"
              onClick={() => setShowSendMessageDialog(true)}
              Icon={PiChatCircleText}
              text="send message"
            ></MessageButton>
            <MessageButton
              id="create-message-schedule-button"
              onClick={() => setShowScheduleMessageDialog(true)}
              Icon={PiBroadcast}
              text="schedule messages"
            ></MessageButton>
          </div>
        </PopoverContent>
      </Popover>
      {showSendMessageDialog && (
        <SendMessage setShowDialog={setShowSendMessageDialog} />
      )}
      {showScheduleMessageDialog && (
        <CreateMessageSchedule setShowDialog={setShowScheduleMessageDialog} />
      )}
    </div>
  );
};
